// GA4 / GTM loader. Injects the vendor script once analytics is enabled via
// the account's ecommerce_settings ({ enable_analytics, analytics_type,
// analytics_id }), then wires analyticsService's track() sink to
// gtag/dataLayer so every app-level track() call reaches GA4 or GTM.
import { setAnalyticsSink } from './analyticsService';

let initializedKey = null;

function ensureDataLayer() {
  window.dataLayer = window.dataLayer || [];
}

function injectScript(src) {
  if (document.querySelector(`script[src="${src}"]`)) return;
  const script = document.createElement('script');
  script.src = src;
  script.async = true;
  document.head.appendChild(script);
}

function loadGA4(measurementId) {
  ensureDataLayer();
  window.gtag =
    window.gtag ||
    function gtag() {
      window.dataLayer.push(arguments);
    };
  injectScript(`https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`);
  window.gtag('js', new Date());
  // send_page_view is off — the router-driven useRoutePageviews() hook emits
  // page_view explicitly so SPA route changes aren't missed/double-counted.
  window.gtag('config', measurementId, { send_page_view: false });

  setAnalyticsSink((event, props) => {
    window.gtag('event', event, props || {});
  });
}

function loadGTM(containerId) {
  ensureDataLayer();
  window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
  injectScript(`https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(containerId)}`);

  if (!document.getElementById('gtm-noscript')) {
    const noscript = document.createElement('noscript');
    noscript.id = 'gtm-noscript';
    const iframe = document.createElement('iframe');
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${encodeURIComponent(containerId)}`;
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';
    noscript.appendChild(iframe);
    document.body.appendChild(noscript);
  }

  setAnalyticsSink((event, props) => {
    window.dataLayer.push({ event, ...(props || {}) });
  });
}

/**
 * @param {{ enable_analytics?: boolean, analytics_type?: string, analytics_id?: string }} settings
 *   ecommerce_settings from the resolved account (see StoreContextBootstrap).
 */
export function initAnalyticsFromEcommerceSettings(settings) {
  if (!settings?.enable_analytics || !settings?.analytics_id) return;

  const type = String(settings.analytics_type || 'GA4').toUpperCase();
  const key = `${type}:${settings.analytics_id}`;
  if (initializedKey === key) return;
  initializedKey = key;

  if (type === 'GTM') {
    loadGTM(settings.analytics_id);
  } else {
    loadGA4(settings.analytics_id);
  }
}
